import { ApplicationContext } from '../../framework/framework/shared/ApplicationContext';
import * as style from './style.css';
import React = require('react');

interface IProps {
    appCtx: ApplicationContext;
    appName: string;
    buildTime: string;
}

interface IState {

}

export default class Footer extends React.Component<IProps, IState> {
    render() {
        return this.renderView();
    }

    renderView() {
        return (
            <>
                <div className={style.wrapper}>

                    <div className={style.footer}>

                        <div className={style.column}>
                            <h3>APC Prodent</h3>
                            <ul>
                                <li><a href={this.props.appCtx.buildUrl('')}>O nas</a></li>
                                <li><a href={this.props.appCtx.buildUrl('/kontakt')}>Kontakt</a></li>
                                <li><a href={this.props.appCtx.buildUrl('polityka_prywatnosci')}>Polityka prywatności</a></li>
                                <li><a href={this.props.appCtx.buildUrl('')}>Regulamin sklepu</a></li>
                                {/* <li>Wyprzedaż</li>
                    <li>Promocje</li>
                    <li>Poradniki</li> */}

                            </ul>
                        </div>
                        <div className={style.column}>
                            <h3>Pomoc</h3>
                            <ul>
                                <li><a href={this.props.appCtx.buildUrl('')}>Cookies</a></li>
                                <li><a href={this.props.appCtx.buildUrl('')}>Zadzwoń</a></li>
                                <li><a href={'#'}>+48 691 057 724</a></li>
                                <li><a href={this.props.appCtx.buildUrl('ochrona_danych')}>Ochrona danych osobowych</a></li>
                            </ul>
                        </div>
                        <div className={style.column}>
                            <h3>Pracownia</h3>
                            <ul>
                                <li><a href={this.props.appCtx.buildUrl('')}>Projekty indywidualne</a></li>
                                <li><a href={this.props.appCtx.buildUrl('')}>Pomiary</a></li>
                                <li><a href={this.props.appCtx.buildUrl('')}>Wycena</a></li>
                                <li><a href={this.props.appCtx.buildUrl('')}>Realizacje</a></li>
                            </ul>
                        </div>
                    </div>
                    <div className={style.systemInfo}>
                        <div>
                            &copy;apcProdent.pl

                        </div>
                        <div>
                            Powered by: &nbsp; <a href="https://www.antes.link">www.antes.link</a>
                        </div>
                        <div>
                            {this.props.buildTime}

                        </div>

                    </div>
                </div>
            </>

        );
    }
}
